// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "4777" ? "monaco-editor" : chunkId) + "." + {"3067": "08566aea","4777": "13f44d2c","5148": "d8530b68","5213": "3253922b","5797": "e5b33855","8297": "01db6b74","8772": "40e2b10f","9123": "25e50ce7",}[chunkId] + ".css"
}